import { addCollect } from '@api/longVideo';
import { uploadFile } from '@api/public';

const publishVideoInfo = (localStorage.getItem('publishVideoInfo') && JSON.parse(localStorage.getItem('publishVideoInfo'))) || {};

let publishVideoStatus = 0;
if (localStorage.getItem('publishVideoStatus')) {
  publishVideoStatus = Number(localStorage.getItem('publishVideoStatus'));
}
const state = () => ({
  hasShowLaunch: false,
  publishVideoInfo,
  publishVideoStatus, // 0 未上传完成， 1上传结束
  nation: ''
});

const mutations = {
  setHasShowLaunch (state, data) {
    state.hasShowLaunch = data;
  },
  setPublishVideoInfo (state, data) {
    state.publishVideoInfo = data;
    localStorage.setItem('publishVideoInfo', JSON.stringify(data));
  },
  setPublishVideoStatus (state, data) {
    state.publishVideoStatus = data;
    localStorage.setItem('publishVideoStatus', data);
  },
  setNation (state, data) {
    state.nation = data;
    localStorage.setItem('nation', data);
  }
};

const actions = {
  collect ({ commit }, params) {
    // status 1点赞 ， 2取消点赞
    // const status = params.is_collect ? 2 : 1;

    let status = '';
    if (params.is_collect === 1) {
      params.is_collect = 0;
      status = 2;
      params.collect_times--;
    } else if (params.is_collect === 0) {
      params.is_collect = 1;
      status = 1;
      params.collect_times++;
    }

    addCollect({ vid: params.id, status }).then(res => {
      // if (res.result === 200000) {
      //   if (status === 1) {
      //     params.is_collect = 1;
      //   } else if (status === 2) {
      //     params.is_collect = 0;
      //   }
      // }
    });
  },
  upload ({ commit }, { file, isVideoImg, type = 2, name = 'image' }) {
    // eslint-disable-next-line no-new
    return new Promise((resolve, reject) => {
      if (file.type.includes('video')) {
        name = 'short';
        type = 1;
      }
      if (isVideoImg) {
        name = 'short';
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', name);
      formData.append('type', type);
      uploadFile(formData).then(res => {
        resolve(res);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
